import React, { useState } from "react";
import {
  Button,
  Box,
  Typography,
  Grid,
  TextField,
  CircularProgress,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  Tooltip
} from "@mui/material";
import SelectableSearch from "../../Base/views/SelectableSearch";
import { AddEACUserHelper, GetExistingEmployeesHelper } from "../helper/CreateUserHelper";
import { checkPayrollAccess, getUserData } from "../../Base/helper/baseFunctions";
import { useSelector } from "react-redux";
import UserSelectionOptions from "./UserSelectionOptions";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const initialFValues = {
  employee_id: "",
  office_email: "",

  title: "",
  first_name: "",
  last_name: "",
  whatsapp_phone_no: "",

  core_hr_user_type: "Admin",
  enable_corehr: true,
  enable_ats: false,
  enable_payroll: false,
  enable_payroll_executive: false,
  enable_finance_executive: false,
  enable_visitor_management: false,
  vm_exec_access: false,
  enable_expense_executive: false,
  enable_lms_executive: false,
  enable_settings_access: false,
  enable_employee_management: false,
  enable_lms: true,
  is_active: true,
  is_external: true,
};

const CreateuserPopup = ({ onClose, currentData, fetchData=() => {} }) => {
  let userData = getUserData();
  const { atsModuleData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleReducer,
  );
  const leaveAccess = atsModuleData?.find(
    (item) => item.module_name === "Leave",
  );
  const [userType, setUserType] = useState(currentData ? "external" : null); // 'existing' or 'external'
  const isExternal = userType === "external";
  const isExisting = userType === "existing";
  const [employeeModalData, setEmployeeModalData] = useState(initialFValues);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });
  const handleEmployees = () => {
    GetExistingEmployeesHelper().then((res) => {
      if (res?.data?.statuscode === 200) {
        setEmployeesData({
          load: false,
          values: (res?.data?.data || [])?.filter((el) => !el?.emp_users),
        });
      }
    });
  };

  const handleReset = () => {
    setUserType(null);
    setEmployeeModalData(initialFValues);
    setIsSubmitting(false);
    setErrors({});
  };

  const handleClose = () => {
    if (!userType) {
      onClose();
    } else {
      handleReset();
    }
  };
  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("employee_id" in fieldValues && isExisting) {
      temp.employee_id =
        !fieldValues.employee_id
          ? "Assigned To is required"
          : "";
    } else {
      temp.employee_id = "";
    }
    if ("title" in fieldValues && isExisting) {
      temp.title =
        !fieldValues.title ? "Title is required" : "";
    } else {
      temp.title = "";
    }
    if ("first_name" in fieldValues) {
      temp.first_name =
        fieldValues.first_name?.trim() === "" ? "First Name is required" : "";
    }
    if ("last_name" in fieldValues) {
      temp.last_name =
        fieldValues.last_name?.trim() === "" ? "Last Name is required" : "";
    }
    if ("office_email" in fieldValues) {
      temp.office_email =
        fieldValues?.office_email?.trim() === "" ||
        fieldValues?.office_email === null
          ? "Email is required"
          : /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                fieldValues.office_email,
              )
            ? ""
            : "Invalid Email.";
    }
    if ("whatsapp_phone_no" in fieldValues) {
      temp.whatsapp_phone_no =
        fieldValues.whatsapp_phone_no?.trim()
          ? /^\d{10}$/.test(fieldValues.whatsapp_phone_no)
            ? ""
            : "Invalid Mobile Number."
          : "";
    }
    if ("enable_payroll" in fieldValues) {
      temp.enable_payroll =
        fieldValues.enable_payroll &&
        !employeeModalData?.enable_payroll_executive &&
        !employeeModalData?.enable_finance_executive
          ? "Please select at least one executive type"
          : "";
    }
    setErrors({ ...temp });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (event, value) => {
    if (event?.target?.name === "core_hr_user_type") {
      setEmployeeModalData({
        ...employeeModalData,
        [event?.target?.name]: event?.target?.value,
        enable_expense_executive: event?.target?.value === "Admin" ? true : false,
        enable_settings_access: event?.target?.value === "Admin" ? true : false,
        enable_employee_management: event?.target?.value === "Admin" ? true : false,
        enable_lms: event?.target?.value === "Admin" ? true : false,
        enable_lms_executive: false,
        enable_payroll: false,
        enable_payroll_executive: false,
        enable_finance_executive: false,
        vm_exec_access: false
      });
    } else if (
      [
        "enable_ats",
        "enable_visitor_management",
        "enable_expense_executive",
        "enable_lms_executive",
        "enable_settings_access",
        "enable_employee_management",
        "enable_lms",
        "vm_exec_access"
      ].includes(event?.target?.name)
    ) {
      const isLMS = event?.target?.name === "enable_lms";
      const isVisitorMg = event?.target?.name === "enable_visitor_management";
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.checked,
        ...(isLMS && { enable_lms_executive: false }),
        ...(isVisitorMg && { vm_exec_access: false })
      });
    } else if (
      ["enable_payroll_executive", "enable_finance_executive"].includes(
        event?.target?.name,
      )
    ) {
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.checked,
      });
      if (errors?.enable_payroll) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          enable_payroll: "",
        }));
      }
    } else if (["enable_payroll"].includes(event?.target?.name)) {
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.checked,
        enable_payroll_executive: false,
        enable_finance_executive: false,
      });
      if (errors?.enable_payroll) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          enable_payroll: "",
        }));
      }
    } else if (["employee_id"].includes(event)) {
      if (value) {
        setEmployeeModalData({
          ...employeeModalData,
          ...value,
          "mail": value?.office_email || "",
          [event]: value,
        });
      } else {
        setEmployeeModalData({ ...employeeModalData, 
          [event]: "", ...initialFValues });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...employeeModalData, ...(value ? value : initialFValues
        ), [event]: value ? value : "" });
    } else {
      setEmployeeModalData({
        ...employeeModalData,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({
          ...employeeModalData,
          [event.target.name]: event.target.value,
        });
    }
  };

  const handleSubmit = async () => {
    if (validate(employeeModalData)) {
      setIsSubmitting(true);
      AddEACUserHelper({
        ...employeeModalData,
        is_external : isExternal ? true : false,
        employee_id: isExternal ? null : employeeModalData?.employee_id?.employee_id
      }).then((res) => {
        if (res?.data?.statuscode === 200) {
          onClose();
          fetchData();
        }
        setIsSubmitting(false);
      })
    }
  };
  const renderInitialOptions = () => (
    <UserSelectionOptions setUserType={setUserType} userType={userType}/>
  );

  return (
    <Box sx={{ py: 2, px: 1 }}>
      <Box sx={{ mb: 2 }}>
        {!userType ? (
          renderInitialOptions()
        ) : (
          <Grid container spacing={2}>
            {isExisting && (
              <Grid item xs={12} md={12}>
                <SelectableSearch
                  label="Select Employee"
                  loading={handleEmployees}
                  value={employeeModalData?.employee_id}
                  required={true}
                  variant={"contained"}
                  fieldLabel={"name"}
                  name="employee_id"
                  size="small"
                  data={employeesData}
                  onChangeEvent={handleInputChange}
                  {...(errors?.employee_id && {
                    error: true,
                    helperText: errors?.employee_id,
                  })}
                />
              </Grid>
            )}
            <Grid item xs={12} md={12}>
              <FormControl
                required
                fullWidth
                error={errors?.core_hr_user_type ? true : false}
                size="small"
              >
                <InputLabel id="recruiter-type-select-label">
                  User Type
                </InputLabel>
                <Select
                  name="core_hr_user_type"
                  labelId="recruiter-type-select-label"
                  id="recruiter-type-select"
                  value={employeeModalData?.core_hr_user_type}
                  label="User Type"
                  onChange={handleInputChange}
                >
                  <MenuItem value={"Admin"}>Admin</MenuItem>
                  {isExisting && (<MenuItem value={"Employee"}>Employee</MenuItem>)}
                </Select>
                <FormHelperText>{errors?.core_hr_user_type}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              {isExisting && (
              <FormControl size="small" sx={{ width: "30%", mr: 1 }} error={errors?.title ? true : false}>
                <InputLabel id="recruiter-type-select-label">Title *</InputLabel>
                <Select
                  label="Title"
                  name="title"
                  id="title"
                  value={employeeModalData?.title}
                  onChange={(e) =>{
                    setEmployeeModalData({
                      ...employeeModalData,
                      title: e.target.value,
                    })
                    errors?.title && setErrors((prevErrors) => ({
                      ...prevErrors,
                      title: "",
                    }))
                   }
                  }
                >
                  <MenuItem value={"Mr"}>Mr</MenuItem>
                  <MenuItem value={"Mrs"}>Mrs</MenuItem>
                  <MenuItem value={"Ms"}>Ms</MenuItem>
                  <MenuItem value={"Miss"}>Miss</MenuItem>
                  <MenuItem value={"Dr"}>Dr</MenuItem>
                  <MenuItem value={"Mx"}>Mx</MenuItem>
                </Select>
                <FormHelperText>{errors?.title}</FormHelperText>
              </FormControl>)}
              <FormControl fullWidth>
                <TextField
                  required
                  size="small"
                  value={employeeModalData.first_name}
                  onChange={handleInputChange}
                  variant="outlined"
                  fullWidth
                  onKeyPress={(e) =>
                    e.target.value?.length >= 35 && e.preventDefault()
                  }
                  onPaste={(e) =>
                    e.target.value?.length >= 35 && e.preventDefault()
                  }
                  id="first_name"
                  label="First Name"
                  name="first_name"
                  autoComplete="first_name"
                  {...(errors.first_name && {
                    error: true,
                    helperText: errors.first_name,
                  })}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  size="small"
                  required
                  value={employeeModalData.last_name}
                  onChange={handleInputChange}
                  variant="outlined"
                  fullWidth
                  id="last_name"
                  label="Last Name"
                  onKeyPress={(e) =>
                    e.target.value?.length >= 35 && e.preventDefault()
                  }
                  onPaste={(e) =>
                    e.target.value?.length >= 35 && e.preventDefault()
                  }
                  name="last_name"
                  autoComplete="last_name"
                  {...(errors.last_name && {
                    error: true,
                    helperText: errors.last_name,
                  })}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                name="office_email"
                label="Email"
                type="email"
                size="small"
                required
                disabled={
                  isExisting &&
                  employeeModalData?.mail?.trim()
                }
                value={employeeModalData?.office_email}
                onChange={handleInputChange}
                variant="outlined"
                {...(errors?.office_email && {
                  error: true,
                  helperText: errors?.office_email,
                })}
              />
            </Grid>
            <Grid item xs={12} md={12}>
                <TextField
                  label="Mobile Number"
                  fullWidth
                  name="whatsapp_phone_no"
                  onChange={handleInputChange}
                  value={employeeModalData?.whatsapp_phone_no || ""}
                  size="small"
                  {...(errors.whatsapp_phone_no && {
                    error: true,
                    helperText: errors.whatsapp_phone_no,
                  })}
                />
              </Grid>
            <Grid item xs={12} mb={-1}>
              <Typography variant="h6">
                Modules & Access
              </Typography>
            </Grid>
            {(isExisting && ["Admin", "Employee"].includes(employeeModalData?.core_hr_user_type)) && <Grid
              item
              xs={12}
              md={6}
              sx={{ padding: "0px 0.75rem", height: "45px" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    disabled
                    name="enable_corehr"
                    checked={employeeModalData?.enable_corehr || false}
                    onChange={handleInputChange}
                  />
                }
                label={
                  <LabelWithInfo
                    label="Enable Core HR"
                  />
                }
              />
            </Grid>}
           {(["Admin", "Employee"].includes(employeeModalData?.core_hr_user_type)) && 
           <Grid
              item
              xs={12}
              md={6}
              sx={{ padding: "0px 0.75rem", height: "45px" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    name="enable_employee_management"
                    checked={
                      employeeModalData?.enable_employee_management || false
                    }
                    onChange={handleInputChange}
                  />
                }
                label={
                  <LabelWithInfo
                    label="Enable Employee Management"
                    tooltip="Allows the user to access and manage employee-related information."
                  />
                }
              />
            </Grid>}
            {userData?.f_country_code === "IND" && leaveAccess && (["Admin", "Employee"].includes(employeeModalData?.core_hr_user_type)) && (
              <Grid
                item
                xs={12}
                md={6}
                sx={{ padding: "0px 0.75rem", height: "45px" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      name="enable_lms"
                      checked={employeeModalData?.enable_lms || false}
                      onChange={handleInputChange}
                    />
                  }
                  label={
                    <LabelWithInfo
                      label="Enable LMS"
                    />
                  }
                />
              </Grid>
            )}
            {userData?.f_country_code === "IND" &&
              leaveAccess &&
              employeeModalData?.enable_lms && isExisting && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ padding: "0px 0.75rem", height: "45px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        name="enable_lms_executive"
                        checked={
                          employeeModalData?.enable_lms_executive || false
                        }
                        onChange={handleInputChange}
                      />
                    }
                    label={
                      <LabelWithInfo
                        label="Enable LMS Executive Access"
                        tooltip="Allows the user to manage leave requests and attendance for employees within their reporting hierarchy."
                      />
                    }
                  />
                </Grid>
              )}

            {userData?.enable_ats && (
              <Grid
                item
                xs={12}
                md={6}
                sx={{ padding: "0px 0.75rem", height: "45px" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      name="enable_ats"
                      checked={employeeModalData?.enable_ats || false}
                      onChange={handleInputChange}
                    />
                  }
                  label={
                    <LabelWithInfo
                      label="Enable ATS"
                    />
                  }
                />
              </Grid>
            )}
            {["Admin"].includes(employeeModalData?.core_hr_user_type) && (
              <Grid
                item
                xs={12}
                md={6}
                sx={{ padding: "0px 0.75rem", height: "45px" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      name="enable_settings_access"
                      checked={
                        employeeModalData?.enable_settings_access || false
                      }
                      onChange={handleInputChange}
                    />
                  }
                  label={
                    <LabelWithInfo
                      label="Enable Settings"
                    />
                  }
                />
              </Grid>
            )}
            {userData?.workspace_visitor_management_flag && (
              <>
              <Grid
                item
                xs={12}
                md={6}
                sx={{ padding: "0px 0.75rem", height: "45px" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      name="enable_visitor_management"
                      checked={
                        employeeModalData?.enable_visitor_management || false
                      }
                      onChange={handleInputChange}
                    />
                  }
                  label={
                    <LabelWithInfo
                      label="Enable Visitor Management"
                      tooltip="Enables access to the core Visitor Management modules, including Pre-registration and Visitor Entry."
                    />
                  }
                />
              </Grid>
              {employeeModalData?.enable_visitor_management && (
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ padding: "0px 0.75rem", height: "45px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        name="vm_exec_access"
                        checked={
                          employeeModalData?.vm_exec_access || false
                        }
                        onChange={handleInputChange}
                      />
                    }
                    label={
                    <LabelWithInfo
                      label={"Enable Visitor Executive Access"}
                      tooltip="Enables additional access to Dashboard and Report along with Pre-registration and Visitor Entry."
                    />
                  }
                  />
                </Grid>
              )}
              </>
            )}
            {userData?.workspace_expense_flag && (
              <Grid
                item
                xs={12}
                md={6}
                sx={{ padding: "0px 0.75rem", height: "45px" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      name="enable_expense_executive"
                      checked={
                        employeeModalData?.enable_expense_executive || false
                      }
                      onChange={handleInputChange}
                    />
                  }
                  label={
                    <LabelWithInfo
                      label="Enable Expense Executive Access"
                      tooltip="Enables access to Team Expenses."
                    />
                  }
                />
              </Grid>
            )}
            {checkPayrollAccess() && (
              <Grid
                container
                xs={12}
                sx={{
                  mt: "12px",
                  ...(employeeModalData?.enable_payroll && {
                    border: "1px solid #e0e0e0",
                    borderRadius: "5px",
                  }),
                }}
              >
                <Grid
                  item
                  xs={12}
                  sx={{ padding: "0px 0.75rem 0px 1rem", height: "45px" }}
                >
                  <FormControl
                    error={
                      errors?.enable_payroll &&
                      !employeeModalData?.enable_payroll_executive &&
                      !employeeModalData?.enable_finance_executive
                    }
                    component="fieldset"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          name="enable_payroll"
                          checked={employeeModalData?.enable_payroll || false}
                          onChange={handleInputChange}
                        />
                      }
                      label={
                        <LabelWithInfo
                          label="Enable Executive Access for Payroll"
                          tooltip="Enables access to the core Payroll Management modules."
                        />
                      }
                    />
                    {errors?.enable_payroll &&
                      !employeeModalData?.enable_payroll_executive &&
                      !employeeModalData?.enable_finance_executive && (
                        <FormHelperText>
                          {errors?.enable_payroll}
                        </FormHelperText>
                      )}
                  </FormControl>
                </Grid>
                {employeeModalData?.enable_payroll && (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sx={{ padding: "0px 0.75rem 0px 1rem", height: "45px" }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            name="enable_payroll_executive"
                            checked={
                              employeeModalData?.enable_payroll_executive ||
                              false
                            }
                            onChange={handleInputChange}
                          />
                        }
                        label={
                          <LabelWithInfo
                            label="Assign as Payroll Executive"
                            tooltip="Allows the user to process and manage payroll operations."
                          />
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sx={{ padding: "0px 0.75rem 0px 1rem", height: "45px" }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            name="enable_finance_executive"
                            checked={
                              employeeModalData?.enable_finance_executive ||
                              false
                            }
                            onChange={handleInputChange}
                          />
                        }
                        label={
                          <LabelWithInfo
                            label="Assign as Finance Executive"
                            tooltip="Allows the user to process and manage payroll operations."
                          />
                        }
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            )}
          </Grid>
        )}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
        {!currentData && (
        <Button onClick={handleClose} variant="text" size="medium">
          {!userType ? "Cancel" : "Back"}
        </Button>)}
        <Button
          onClick={handleSubmit}
          className="mpl-primary-btn"
          variant="contained"
          size="medium"
          disabled={!userType || isSubmitting}
          startIcon={
            isSubmitting ? <CircularProgress size={18} color="inherit" /> : null
          }
        >
          {currentData ? "Update" : "Create User"}
        </Button>
      </Box>
    </Box>
  );
};


const LabelWithInfo = ({ label, tooltip }) => (
  <Typography
    variant="body1"
    color="inherit"
    sx={{
      fontSize: 13,
      display: "flex",
      alignItems: "center",
      gap: 0.5,
    }}
  >
    {label}

    {tooltip && (
      <Tooltip title={tooltip} arrow placement="top">
        <InfoOutlinedIcon
          color="action"
          sx={{
            cursor: "pointer",
            fontSize: 16,
          }}
        />
      </Tooltip>
    )}
  </Typography>
);

export default CreateuserPopup;
